import * as yup from 'yup';

function warrantyType(formatMessage) {
  return yup
    .string()
    .required(
      formatMessage({
        id: 'WARRANTY_TYPE_IS_REQUIRED',
        defaultMessage: 'Warranty Type is required',
      }),
    )
    .max(
      64,
      formatMessage({
        id: 'CREATEFORM_WARRANTYTYPE_FIELD_MAX_CHARS_64',
        defaultMessage: 'Warranty Type should be less than 64 chars',
      }),
    );
}

function warrantyTypeCode(formatMessage) {
  return yup
    .string()
    .required(
      formatMessage({
        id: 'WARRANTY_TYPE_CODE_IS_REQUIRED',
        defaultMessage: 'Warranty Type Code is required',
      }),
    )
    .max(
      32,
      formatMessage({
        id: 'CREATEFORM_WARRANTYTYPECODE_FIELD_MAX_CHARS_32',
        defaultMessage: 'Warranty Type Code should be less than 32 chars',
      }),
    );
}

function status(formatMessage) {
  return yup.string().required(
    formatMessage({
      id: 'STATUS_IS_REQUIRED',
      defaultMessage: 'Status is required',
    }),
  );
}

const validationSchema = formatMessage =>
  yup
    .object({
      warrantyType: warrantyType(formatMessage),
      warrantyTypeCode: warrantyTypeCode(formatMessage),
      status: status(formatMessage),
    })
    .required();

export default validationSchema;
